import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EventShareSheet, eventCta } from "./wall/WallEventCard";
import usePosterReveal from "./wall/usePosterReveal";
import { Faces, RingButton, ShareGlyph, ago } from "./people/PeopleUI";

export default function PeopleActivityCard({ item, onOpen }) {
  const navigate = useNavigate();
  const event = item.event;
  const [share, setShare] = useState(false);
  const [ratio, setRatio] = useState(event.posterAspectRatio || 16 / 9);
  const poster = usePosterReveal(
    event.posterUrl,
    setRatio,
    event.posterUnavailable
  );
  const going = item.type === "you_going";
  const friends = item.interestedFriends?.length
    ? item.interestedFriends
    : [
        {
          userId: item.actorUserId,
          name: item.actorName,
          avatarUrl: item.actorAvatarUrl,
        },
      ];
  const interested = item.type === "friend_interested";
  const open = () =>
    onOpen ? onOpen(event) : navigate("/events/" + event.inviteCode);
  const { priceText } = eventCta(event);
  const date = event.dateTime
    ? new Date(event.dateTime).toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      })
    : "";
  return (
    <article
      className="people-event"
      data-testid="people-activity"
      aria-busy={!poster.ready}
    >
      <div
        style={{
          opacity: poster.ready ? 1 : 0,
          transition: "opacity 300ms",
          pointerEvents: poster.ready ? undefined : "none",
        }}
        inert={!poster.ready}
      >
        <div className="people-event-attribution">
          <Faces people={going ? [] : friends} />
          <span>
            {going ? (
              <b>You're going</b>
            ) : (
              <>
                <b>{friends[0]?.name || item.actorName}</b>
                {interested
                  ? friends.length > 1
                    ? " + " + (friends.length - 1) + " are interested"
                    : " is interested"
                  : item.type === "friend_joined"
                  ? " joined"
                  : " started an event"}
              </>
            )}
          </span>
          <time dateTime={item.occurredAt}>{ago(item.occurredAt)}</time>
        </div>
        <div
          className="people-event-cover"
          style={{ aspectRatio: ratio < 0.95 ? "4 / 5" : "16 / 9" }}
        >
          <button
            type="button"
            onClick={open}
            aria-label={"View " + event.title}
          >
            {event.posterUrl && !poster.failed ? (
              <img
                ref={poster.imageRef}
                src={event.posterUrl}
                alt=""
                onLoad={poster.onLoad}
                onError={poster.onError}
                referrerPolicy="no-referrer"
              />
            ) : (
              <span className="people-meta">Let's get together</span>
            )}
          </button>
          <span className="people-event-type">
            {event.fundingType === "party_starter"
              ? "Party starter"
              : "Guaranteed"}
          </span>
          <RingButton
            onClick={() => setShare(true)}
            label={"Share " + event.title}
          >
            <ShareGlyph />
          </RingButton>
        </div>
        <div className="people-event-body">
          <div className="people-event-date">{date}</div>
          <button type="button" className="people-event-title" onClick={open}>
            {event.title}
          </button>
          <div className="people-meta">{event.locationCity}</div>
          <div className="people-event-bottom">
            <span className="people-event-price">{priceText}</span>
            <button
              type="button"
              className={"people-pill " + (going ? "is-done" : "")}
              onClick={open}
            >
              {going ? "Going ✓" : "Join →"}
            </button>
          </div>
        </div>
      </div>
      <EventShareSheet
        event={event}
        open={share}
        onClose={() => setShare(false)}
      />
    </article>
  );
}
